<template>
    <div>
         <Paper class="myTender">
            <Table :tableData="tableData" :tableHeaders="tableHeaders"></Table>
        </Paper>
    </div>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import Table from './myTender';
import tableData from './configs/tenderTableData';
import tableHeaders from './configs/tenderTableHeader';
export default {
    data() {
        return {
            tableHeaders,
            tableData
        };
    },
    components: { Paper, Table },
    methods: {
    },
    mounted() {
    }
};
</script>
<style lang="less">
</style>